import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { useTranslation } from "react-i18next";
import logoMark from "../assets/images/hububble-mark-white.svg";
import { consoleLockup } from "../helpers/consoleLockup";

//Import Components
import VerticalLayout from "./VerticalLayouts";
import { Container } from "reactstrap";

const Sidebar = ({ layoutType }) => {
  const { i18n } = useTranslation();
  const logoLg = consoleLockup(i18n.language);
  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  });

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (
      document.documentElement.getAttribute("data-sidebar-size") === "sm-hover"
    ) {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );
    } else if (
      document.documentElement.getAttribute("data-sidebar-size") ===
      "sm-hover-active"
    ) {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    }
  };
  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box">
          {/* The sidebar is always dark, so both variants use the white logo */}
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logoMark} alt="Hububble" height="28" />
            </span>
            <span className="logo-lg">
              <img src={logoLg} alt="Hububble" height="40" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoMark} alt="Hububble" height="28" />
            </span>
            <span className="logo-lg">
              <img src={logoLg} alt="Hububble" height="40" />
            </span>
          </Link>
          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>
        {/* The layout is always vertical: the template's horizontal and
            two-column layouts were removed (HXSMSF-144) */}
        <SimpleBar id="scrollbar">
          <Container fluid className="h-100">
            <div id="two-column-menu"></div>
            <ul className="navbar-nav h-100" id="navbar-nav">
              <VerticalLayout layoutType={layoutType} />
            </ul>
          </Container>
        </SimpleBar>
        <div className="sidebar-background"></div>
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
